// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JKOv","delete":"styles_delete__3YBb0","update":"styles_update__QPpip","add":"styles_add__1Tkj1"};